import { useEffect, useState } from "react";
import { api } from "../api";

export const Map = ({ height = 420 }) => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setCfg(r.data)).catch(() => setCfg({}));
  }, []);

  if (!cfg) {
    return <div className="w-full bg-[#121212] animate-pulse rounded-xl" style={{ height }} data-testid="map-loading" />;
  }

  const src = cfg.maps_embed
    ? `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(cfg.maps_key)}&q=${encodeURIComponent(cfg.map_query)}`
    : `https://maps.google.com/maps?q=${encodeURIComponent(cfg.map_query)}&z=13&output=embed`;
  return (
    <iframe
      title="Chinook K9 location map"
      data-testid="google-map-embed"
      className="w-full border-0 rounded-xl"
      style={{ height }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
      src={src}
    />
  );
};
